import { IDriverSafetyDataStore, ISafetyDriverInsight } from "../store/types";

export function cleanUpSafetyDriverInsightData(safetyDriverInsights: ISafetyDriverInsight[]): IDriverSafetyDataStore[] {
    return safetyDriverInsights.map(safetyDriverInsight => {
        return {
            crashProbabilityKm: safetyDriverInsight.crashProbabilityKm,
            crashProbabilityMile: safetyDriverInsight.crashProbabilityMile,
            crashProbabilityBenchmarkKm: safetyDriverInsight.crashProbabilityBenchmarkKm,
            crashProbabilityBenchmarkMile: safetyDriverInsight.crashProbabilityBenchmarkMile,
            harshAccelerationRange: safetyDriverInsight.harshAccelerationRange,
            harshAccelerationRank: safetyDriverInsight.harshAccelerationRank,
            harshBrakingRange: safetyDriverInsight.harshBrakingRange,
            harshBrakingRank: safetyDriverInsight.harshBrakingRank,
            harshCorneringRange: safetyDriverInsight.harshCorneringRange,
            harshCorneringRank: safetyDriverInsight.harshCorneringRank,
            speedingRange: safetyDriverInsight.speedingRange,
            speedingRank: safetyDriverInsight.speedingRank,
            observationDate: safetyDriverInsight.observationDate,
            tailgatingRank: safetyDriverInsight.tailgatingRank,
            tailgatingRange: safetyDriverInsight.tailgatingRange,
            metadata: safetyDriverInsight.metadata,
            crashProbabilityBestInClassKm: safetyDriverInsight.crashProbabilityBestInClassKm,
            crashProbabilityBestInClassMile: safetyDriverInsight.crashProbabilityBestInClassMile,
            crashProbabilityRange: safetyDriverInsight.crashProbabilityRange,
            crashProbabilityRank: safetyDriverInsight.crashProbabilityRank,
            majorVersion: safetyDriverInsight.majorVersion
        };
    });
}
